import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../_metronic/helpers'
import {
  ContractTermResponse,
  TContractTermRequest,
} from '../../../coreGlobal/models/admin/contractTerm'
import {ContractTermsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const CONTRACT_TERM_URL = `${API_URL}/admin/contract-terms`

const getContractTerms = (query: string): Promise<ContractTermsQueryResponse> => {
  return axios
    .get(`${CONTRACT_TERM_URL}?${query}`)
    .then((d: AxiosResponse<ContractTermsQueryResponse>) => d.data)
}

const getContractTermById = (id: string | number): Promise<ContractTermResponse> => {
  return axios
    .get(`${CONTRACT_TERM_URL}/${id}`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const createContractTerm = (data: TContractTermRequest) => {
  return axios
    .post(`${CONTRACT_TERM_URL}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const updateContractTerm = (id: string | number, data: TContractTermRequest) => {
  return axios
    .put(`${CONTRACT_TERM_URL}/${id}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const deleteContractTerm = (id: ID) => {
  return axios.delete(`${CONTRACT_TERM_URL}/${id}`).then((response: any) => response.data)
}

export {
  getContractTerms,
  getContractTermById,
  createContractTerm,
  updateContractTerm,
  deleteContractTerm,
}
